export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      {/* Subtle background mesh */}
      <div className="absolute inset-0 bg-mesh opacity-40"></div>
      {/* Top divider */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/40 to-transparent"></div>
      {/* Decorative orb */}
      <div className="bg-orb bg-orb-primary w-[350px] h-[350px] top-[10%] -left-[100px] animate-orb-float-slow opacity-30"></div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 relative">
        <div className="rounded-3xl overflow-hidden h-[280px] md:h-[380px] relative">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20product%20collage%20with%20sneakers%20hoodies%20bags%20and%20accessories%20on%20warm%20cream%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%20style%2C%20warm%20beige%20neutral%20tones%2C%20minimalist%20artistic%20composition%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20elegant%20lifestyle%20display%2C%20organic%20textures%2C%20no%20text%2C%20sophisticated%20fashion%20arrangement&width=1600&height=800&seq=cta-collage-bg&orientation=landscape"
            alt="CSSBuy Spreadsheet Product Collection"
            title="CSSBuy Spreadsheet Products"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/20 via-foreground-950/15 to-foreground-950/40"></div>
        </div>

        <div className="text-center mt-12 md:mt-16">
          <h2 className="font-heading font-bold text-[32px] md:text-[40px] leading-[1.2] text-foreground-950 max-w-[700px] mx-auto">
            Ready to explore the best{' '}
            <span className="text-foreground-300 italic font-light">CSSBuy Sheet</span>
            {' '}collection with{' '}
            <span className="text-foreground-300 italic font-light">free links</span>?
          </h2>
          <div className="mt-10">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore kaspreadsheet.com
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}